export default __webpack_public_path__ + "static/media/background-planets.898cf070.png";